import { Select, styled } from '@mui/material';
import LanguageSelectorItem from 'Components/Forms/LanguageSelectorItem';
import { StyledInput } from 'Components/Forms/StyledMultiSelect';
import useConfig from 'hooks/useConfig';
import React, { FC } from 'react';
import { ELanguage } from 'DesignSystem/types/language.types';

interface ILanguageSingleSelectProps {
  selectedLanguage: ELanguage;
  setSelectedLanguage: (language: ELanguage) => void;
  languages: Array<{ title: string; key: ELanguage; flag: string }>;
}

const StyledSelect = styled(Select<ELanguage>)<{ error?: boolean; size?: 'small' | 'medium' }>(
  ({ theme, error, size = 'medium' }) => ({
    border: '1px solid',
    borderColor: error ? theme.palette.error.main : 'rgba(0, 0, 0, 0.23)',
    borderRadius: 4,
  })
);

const LanguageSingleSelect: FC<ILanguageSingleSelectProps> = ({
  selectedLanguage,
  setSelectedLanguage,
  languages,
  ...props
}) => {
  const config = useConfig();
  return (
    <StyledSelect
      value={selectedLanguage}
      onChange={event => setSelectedLanguage(event.target.value as ELanguage)}
      variant="outlined"
      defaultValue={undefined}
      data-testid="default-language-select"
      fullWidth
      input={<StyledInput />}
      {...props}
      renderValue={selectedItem => {
        const { flag, title } = config.getLanguageConfig(selectedItem);
        return (
          <LanguageSelectorItem
            value={selectedItem}
            flag={flag}
            title={title}
            noPadding
            hoverBackground={false}
          />
        );
      }}
    >
      {languages.map(({ title, key, flag }) => {
        return (
          <LanguageSelectorItem
            value={key}
            key={`product-lang-${key}`}
            flag={flag}
            title={title}
            noPadding={false}
            hoverBackground={false}
          />
        );
      })}
    </StyledSelect>
  );
};

export default LanguageSingleSelect;
